import axios from 'axios'

// Default Axios instance for API
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://10.8.0.1:8002/',
})

// Request interceptor - adds auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor - handles 401 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
    }
    return Promise.reject(error)
  }
)

// Axios instance for Public (PostgREST)
const publicInstance = axios.create({
  baseURL: import.meta.env.VITE_PUBLIC_URL || 'http://10.8.0.1:7999/',
})

publicInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

publicInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
    }
    return Promise.reject(error)
  }
)

// Axios instance for LogDB (no auth needed)
const logdbInstance = axios.create({
  baseURL: import.meta.env.VITE_LOGDB_URL || 'https://logdb.sensorbox.pl/pgrst',
})

export { publicInstance, logdbInstance }
export default axiosInstance
